import { createFileRoute } from '@tanstack/react-router'
import { TablePageLoader } from '@/components/ui/page-loader'
import LazyRoute from '../components/LazyRoute'

export const Route = createFileRoute('/_protected/')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/pages/Endpoints')}
      fallback={<TablePageLoader />}
    />
  ),
})